import { render, staticRenderFns } from "./404.vue?vue&type=template&id=21432efa&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../igi-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports